/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import Stack from "@mui/material/Stack";

// Material Kit 2 React components
import MKBox from "../../components/MKBox";
import MKTypography from "../../components/MKTypography";

// Material Kit 2 React examples
import DefaultNavbar from "../../examples/Navbars/DefaultNavbar";
import DefaultFooter from "../../examples/Footers/DefaultFooter";

// Sections
import ContactUs from "../EmtayPage/sections/ContactUs";

// Routes
import routeKeys from "../../routeKeys";

// i18n
import { useLanguage } from "../../i18n";

import { legalbar } from "../EmtayPage/sections/legalbar";

// Images
import bgImage from "../../assets/images/emtay/bg-emtay.webp";

// Styles
import styles from "assets/scss/emtay.module.scss";

function ContactPage() {
  const { t } = useLanguage();

  // Translate routes
  const routes = routeKeys.map((route) => ({
    ...route,
    name: t(route.key),
  }));

  const summaryPoints = [
    { text: t("contactPage.summary1"), icon: "code" },
    { text: t("contactPage.summary2"), icon: "assessment" },
    { text: t("contactPage.summary3"), icon: "psychology" },
  ];

  return (
    <>
      <a name="top" />
      <DefaultNavbar routes={routes} transparent light />
      <MKBox
        width="100%"
        sx={{
          minHeight: { xs: "26rem", md: "22rem" },
          height: { xs: "48vh", md: "40vh" },
          maxHeight: { xs: "38rem", md: "34rem" },
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "grid",
          placeItems: "center",
        }}
      >
        <Container>
          <Grid
            container
            item
            xs={12}
            lg={8}
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
            sx={{
              mx: "auto",
              textAlign: "center",
              pt: { xs: 10, sm: 11, md: 12, lg: 0 },
            }}
          >
            <MKTypography variant="h2" color="white">
              {t("contactPage.title")}
            </MKTypography>
            <MKTypography variant="body1" color="white" opacity={0.8} mt={1} mb={3}>
              {t("contactPage.subtitle")}
            </MKTypography>
          </Grid>
        </Container>
      </MKBox>
      <Card
        sx={{
          p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 2,
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <Container sx={{ py: 4 }}>
          {/* Merged Intro + Summary Section */}
          <MKBox
            component="section"
            py={6}
            sx={{ backgroundColor: "#f8f9fa", borderRadius: 2, mb: 6 }}
          >
            <Grid container alignItems="center">
              <Grid item xs={12} lg={5}>
                <MKTypography variant="h3" my={1}>
                  {t("contactPage.intro")}
                </MKTypography>
                <MKTypography variant="body2" color="text" mt={2}>
                  {t("contactPage.howWeHelpDesc")}
                </MKTypography>
              </Grid>
              <Grid item xs={12} lg={6} sx={{ ml: { xs: -2, lg: "auto" }, mt: { xs: 6, lg: 0 } }}>
                <Stack className={styles.servicesBlock}>
                  {summaryPoints.map((point, index) => (
                    <MKBox display="flex" alignItems="center" p={2} key={index}>
                      <MKBox
                        width="3rem"
                        height="3rem"
                        variant="gradient"
                        bgColor="info"
                        color="white"
                        coloredShadow="info"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        borderRadius="xl"
                        className={styles.iconBox}
                        mr={2}
                      >
                        <Icon fontSize="small">{point.icon}</Icon>
                      </MKBox>
                      <MKTypography variant="body2" color="text">
                        {point.text}
                      </MKTypography>
                    </MKBox>
                  ))}
                </Stack>
              </Grid>
            </Grid>
          </MKBox>

          {/* Contact Form */}
          <a name="contact" />
          <ContactUs isThanks={false} />
        </Container>
      </Card>
      <MKBox pt={2} px={1} mt={0} py={0}>
        <DefaultFooter content={{ copyright: legalbar }} />
      </MKBox>
    </>
  );
}

export default ContactPage;
